import { TaxDetailsFormProps } from '@/src/components/common/forms/taxDetailsForm'
import { TaxDetails } from '@/src/types/itinerary'
import { useCallback, useMemo, useState } from 'react'

export const useTaxDetails = () => {
    const initialTaxDetails: TaxDetails = useMemo(() => {
        return {
            addTaxChecked: false,
            companyName: '',
            taxNo: ''
        }
    }, [])

    const [taxDetails, setTaxDetails] = useState<TaxDetails>(initialTaxDetails)

    const onChangeTaxDetails: TaxDetailsFormProps['onChange'] = useCallback((key, value) => {
        const isString = typeof value === 'string'
        setTaxDetails(prev => ({ ...prev, [key]: isString ? value.trim() : value }))
    }, [])

    return {
        taxDetails,
        setTaxDetails,
        onChangeTaxDetails
    }
}
